import PageWrapper from "theme/components/wrappers/PageWrapper";
import PropTypes from "prop-types";
import React from "react";
import Search from "theme/components/search/Search";

const SearchPage = () => {
    return (
        <PageWrapper mt="16px">
            <Search />
        </PageWrapper>
    );
};

SearchPage.propTypes = {
    data: PropTypes.object.isRequired,
};

export default SearchPage;
